import { render, staticRenderFns } from "./CopasstPagination.vue?vue&type=template&id=175c23cf&"
import script from "./CopasstPagination.vue?vue&type=script&lang=js&"
export * from "./CopasstPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports